import * as layout from "../../routes/$layout.js";
export { layout };
export { default as ErrorComponent } from "../components/error.js";

export const components = [
	() => import("../../routes/index.js"),
	() => import("../../routes/about.js")
];

export const routes = [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// about.svelte
		pattern: /^\/about\/?$/,
		parts: [
			{ i: 1 }
		]
	}
];